module.exports = __webpack_public_path__ + "img/379.fd954c7d.jpg";